// Minimal Segment.io integration

// Define types for Segment analytics
interface SegmentAnalytics {
  track: (event: string, properties?: Record<string, unknown>) => void;
  page: (category?: string, name?: string, properties?: Record<string, unknown>) => void;
  identify: (userId: string, traits?: Record<string, unknown>) => void;
}

interface WindowWithAnalytics extends Window {
  analytics?: SegmentAnalytics;
}

// Get the analytics instance from window
const getAnalytics = (): SegmentAnalytics => {
  if (typeof window !== 'undefined' && (window as WindowWithAnalytics).analytics) {
    return (window as WindowWithAnalytics).analytics as SegmentAnalytics;
  }
  // Return no-op if analytics is not available
  return {
    track: () => {},
    page: () => {},
    identify: () => {}
  };
};

// Track page views
export const trackPage = (pageName?: string) => {
  getAnalytics().page(pageName);
};

// Track events
export const trackEvent = (event: string, properties: Record<string, unknown> = {}) => {
  getAnalytics().track(event, properties);
};

export default {
  trackPage,
  trackEvent
};